import * as Yup from "yup";
import { quotationBoqItemSchema } from "features/Quotations/QuotationForm/schema";

export default Yup.object({
  requiredDate: Yup.string().trim().required("Required date is required"),
  items: Yup.array()
    .of(quotationBoqItemSchema)
    .min(1, "Please add at least one line item")
    .required("Please add at least one line item"),
});
